import script from "./showAnnotations.vue?vue&type=script&setup=true&lang=js"
export * from "./showAnnotations.vue?vue&type=script&setup=true&lang=js"

import "./showAnnotations.vue?vue&type=style&index=0&id=34070416&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34070416"]])

export default __exports__